export const ABORTIVE_VISIT_CHARGE_LINK = 'https://www.bt.com/pricing/current/Misc_boo/1393_d0e1.htm#1393-d0e1';
export const ABORTIVE_VISIT_CHARGE_LABEL = 'Abortive Visit Charge';
